import { AppVersion } from 'data/terra/AppVersion';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import {
  FetchResourceAction,
  fetchResourceDelegate,
  Resource,
  ResourceActionTypes,
} from 'v2/store/common/Resource';
import { ProjectDetailState } from '../state';
import { selectAppVersion } from './SelectAppVersion';

const ActionTypes: ResourceActionTypes = {
  requestFetching: 'project/appVersions/fetch',
  fetchSuccess: 'project/appVersions/fetchSuccess',
  fetchFailure: 'project/appVersions/fetchFailure',
};

export type FetchAppVersionsAction = FetchResourceAction<AppVersion[]>;

export const fetchAppVersionsForSelectedApp = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async (dispatch, getState) => {
  const selectedAppId = getState().projectDetail.selectedApp?.id;
  if (selectedAppId) {
    dispatch(fetchAppVersions(selectedAppId));
  }
};

const fetchAppVersions = (
  appId: string
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  dispatch({
    type: ActionTypes.requestFetching,
  } as FetchAppVersionsAction);

  const result = await Terra.app.fetchAppVersions(appId);

  if (result.isSuccess()) {
    const versions = result.get()!.data;
    dispatch({
      type: ActionTypes.fetchSuccess,
      data: versions,
    } as FetchAppVersionsAction);
    if (versions.length > 0) {
      dispatch(selectAppVersion(versions[0]));
    }
  } else {
    dispatch({
      type: ActionTypes.fetchFailure,
      error: result.exception(),
    } as FetchAppVersionsAction);
  }
};

export const fetchAppVersionsDelegate = fetchResourceDelegate<
  ProjectDetailState,
  AppVersion[]
>(
  ActionTypes,
  (
    rootState: ProjectDetailState,
    reduce: (state: Resource<AppVersion[]>) => Resource<AppVersion[]>
  ) => {
    return {
      ...rootState,
      appVersions: reduce(rootState.appVersions),
    };
  }
);
